import {
    Hotel,
    BedDouble,
    TentTree,
    UtensilsCrossed,
    Stethoscope,
    Scissors,
    Dumbbell,
    ShoppingBag,
    Briefcase,
    Store,
} from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const SEGMENTS = [
    { icon: Hotel, label: "Hotéis" },
    { icon: BedDouble, label: "Pousadas" },
    { icon: TentTree, label: "Chalés" },
    { icon: UtensilsCrossed, label: "Restaurantes" },
    { icon: Stethoscope, label: "Clínicas" },
    { icon: Scissors, label: "Salões" },
    { icon: Dumbbell, label: "Academias" },
    { icon: ShoppingBag, label: "Lojas" },
    { icon: Briefcase, label: "Prestadores de serviços" },
    { icon: Store, label: "Pequenos negócios" },
];

const Audience = () => (
    <section id="para-quem" data-testid="para-quem-section" className="py-24 sm:py-32 scroll-mt-16">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeading
                eyebrow="Para quem é"
                title={
                    <>
                        Para negócios que querem parecer tão profissionais{" "}
                        <span className="text-gold-grad">quanto realmente são.</span>
                    </>
                }
            />

            <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                {SEGMENTS.map((s, i) => (
                    <Reveal key={s.label} delay={0.04 * i} className="h-full">
                        <article
                            data-testid={`segment-card-${i + 1}`}
                            className="card-hover group h-full rounded-2xl border border-line bg-card px-5 py-8 flex flex-col items-center gap-5 text-center"
                        >
                            <div className="relative">
                                <div className="w-12 h-12 rounded-xl border border-line bg-bg2 flex items-center justify-center text-ink2 group-hover:text-gold group-hover:border-gold/50 transition-colors duration-500">
                                    <s.icon size={20} strokeWidth={1.5} />
                                </div>
                                <span className="absolute -top-1 -right-1 w-1.5 h-1.5 rotate-45 bg-gold/0 group-hover:bg-gold transition-colors duration-500" />
                            </div>
                            <h3 className="text-sm font-medium text-ink2 group-hover:text-ink transition-colors duration-500 leading-snug">
                                {s.label}
                            </h3>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Audience;
